import { PageMeta } from '../pages';

import { firstJuly2025ArticleData, firstJuly2025ArticleMeta } from './first-july-2025-article';

import { secondJuly2025ArticleData, secondJuly2025ArticleMeta } from './second-july-2025-article';
import { thirdJuly2025ArticleData, thirdJuly2025ArticleMeta } from './third-july-2025-article';
import { forthJuly2025ArticleData, forthJuly2025ArticleMeta } from './forth-july-2025-article';
import {
  firstAugust2025ArticleData,
  firstAugust2025ArticleMeta,
} from './first-august-2025-article';
import {
  secondAugust2025ArticleData,
  secondAugust2025ArticleMeta,
} from './second-august-2025-article';
import {
  thirdAugust2025ArticleData,
  thirdAugust2025ArticleMeta,
} from './third-august-2025-article';
import {
  forthAugust2025ArticleData,
  forthAugust2025ArticleMeta,
} from './forth-august-2025-article';

import { ArticleSections } from 'types/articles';
import {
  firstSeptember2025ArticleData,
  firstSeptember2025ArticleMeta,
} from './first-september-2025-article';
import {
  secondSeptember2025ArticleData,
  secondSeptember2025ArticleMeta,
} from './second-september-2025-article';
import {
  thirdSeptember2025ArticleData,
  thirdSeptember2025ArticleMeta,
} from './third-september-2025-article';
import {
  forthSeptember2025ArticleData,
  forthSeptember2025ArticleMeta,
} from './forth-september-2025-article';
import {
  fifthSeptember2025ArticleData,
  fifthSeptember2025ArticleMeta,
} from './fifth-september-2025-article';
import {
  firstOctober2025ArticleData,
  firstOctober2025ArticleMeta,
} from './first-october-2025-article';
import {
  secondOctober2025ArticleData,
  secondOctober2025ArticleMeta,
} from './second-october-2025-article';
import {
  thirdOctober2025ArticleData,
  thirdOctober2025ArticleMeta,
} from './third-october-2025-article';
import {
  forthOctober2025ArticleData,
  forthOctober2025ArticleMeta,
} from './forth-october-2025-article';
import {
  thirdNovember2025ArticleData,
  thirdNovember2025ArticleMeta,
} from './third-november-2025-article';
import {
  seventhNovember2025ArticleData,
  seventhNovember2025ArticleMeta,
} from './seventh-november-2025-article';
import {
  tenthNovember2025ArticleData,
  tenthNovember2025ArticleMeta,
} from './tenth-november-2025-article';
import {
  twelvethNovember2025ArticleData,
  twelvethNovember2025ArticleMeta,
} from './twelveth-november-2025-article';
import {
  fourteenthNovember2025ArticleData,
  fourteenthNovember2025ArticleMeta,
} from './fourteenth-november-2025-article';

interface ArticleParameters {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const ARTICLES: ArticleParameters[] = [
  {
    pageMeta: firstJuly2025ArticleMeta,
    articleData: firstJuly2025ArticleData,
  },
  {
    pageMeta: secondJuly2025ArticleMeta,
    articleData: secondJuly2025ArticleData,
  },
  {
    pageMeta: thirdJuly2025ArticleMeta,
    articleData: thirdJuly2025ArticleData,
  },
  {
    pageMeta: forthJuly2025ArticleMeta,
    articleData: forthJuly2025ArticleData,
  },
  {
    pageMeta: firstAugust2025ArticleMeta,
    articleData: firstAugust2025ArticleData,
  },
  {
    pageMeta: secondAugust2025ArticleMeta,
    articleData: secondAugust2025ArticleData,
  },
  {
    pageMeta: thirdAugust2025ArticleMeta,
    articleData: thirdAugust2025ArticleData,
  },
  {
    pageMeta: forthAugust2025ArticleMeta,
    articleData: forthAugust2025ArticleData,
  },
  {
    pageMeta: firstSeptember2025ArticleMeta,
    articleData: firstSeptember2025ArticleData,
  },
  {
    pageMeta: secondSeptember2025ArticleMeta,
    articleData: secondSeptember2025ArticleData,
  },
  {
    pageMeta: thirdSeptember2025ArticleMeta,
    articleData: thirdSeptember2025ArticleData,
  },
  {
    pageMeta: forthSeptember2025ArticleMeta,
    articleData: forthSeptember2025ArticleData,
  },
  {
    pageMeta: fifthSeptember2025ArticleMeta,
    articleData: fifthSeptember2025ArticleData,
  },
  {
    pageMeta: firstOctober2025ArticleMeta,
    articleData: firstOctober2025ArticleData,
  },
  {
    pageMeta: secondOctober2025ArticleMeta,
    articleData: secondOctober2025ArticleData,
  },
  {
    pageMeta: thirdOctober2025ArticleMeta,
    articleData: thirdOctober2025ArticleData,
  },
  {
    pageMeta: forthOctober2025ArticleMeta,
    articleData: forthOctober2025ArticleData,
  },
  {
    pageMeta: thirdNovember2025ArticleMeta,
    articleData: thirdNovember2025ArticleData,
  },
  {
    pageMeta: seventhNovember2025ArticleMeta,
    articleData: seventhNovember2025ArticleData,
  },
  {
    pageMeta: tenthNovember2025ArticleMeta,
    articleData: tenthNovember2025ArticleData,
  },
  {
    pageMeta: twelvethNovember2025ArticleMeta,
    articleData: twelvethNovember2025ArticleData,
  },
  {
    pageMeta: fourteenthNovember2025ArticleMeta,
    articleData: fourteenthNovember2025ArticleData,
  },
];

export const ARTICLES_URLS = ARTICLES.map((article) => article.pageMeta.url);
